import { render, staticRenderFns } from "./IconLabelling.vue?vue&type=template&id=045a2b94&"
import script from "./IconLabelling.vue?vue&type=script&lang=js&"
export * from "./IconLabelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045a2b94')) {
      api.createRecord('045a2b94', component.options)
    } else {
      api.reload('045a2b94', component.options)
    }
    module.hot.accept("./IconLabelling.vue?vue&type=template&id=045a2b94&", function () {
      api.rerender('045a2b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconLabelling.vue"
export default component.exports